import { ShippingRulesMapper } from './ShippingRulesMapper.js';

class ShippingRulesRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  save(userId, shippingRule) {
    return (shippingRule.id ? this.apiClient.put(`${getBaseUrl(userId)}/${shippingRule.id}`, shippingRule) : this.apiClient.post(getBaseUrl(userId), shippingRule)).then(response => response.data);
  }
  getAll(userId) {
    return this.apiClient.get(`${getBaseUrl(userId)}`).then(response => response.data.map(ruleResponse => ShippingRulesMapper.createRuleFromResponse(ruleResponse)));
  }
  get(userId, ruleId) {
    return this.apiClient.get(`${getBaseUrl(userId)}/${ruleId}`).then(response => ShippingRulesMapper.createRuleFromResponse(response.data));
  }
  enable(userId, ruleId, value) {
    return this.apiClient.post(`${getBaseUrl(userId)}/${ruleId}/enable`, {
      value
    }).then(response => response.data);
  }
  switchOrder(userId, ruleId1, ruleId2) {
    return this.apiClient.post(`${getBaseUrl(userId)}/switch-order`, {
      from: ruleId1,
      to: ruleId2
    }).then(response => response.data);
  }
  delete(userId, ruleId) {
    return this.apiClient.delete(`${getBaseUrl(userId)}/${ruleId}`).then(response => response.data);
  }
}
function getBaseUrl(userId) {
  return `v1/users/${userId}/shipping-rules`;
}

export { ShippingRulesRepository };
//# sourceMappingURL=ShippingRulesRepository.js.map
